export default {
    methods: {
        _transformEmployee(name, surname) {
            return (`${name[0]}${surname[0]}`).toUpperCase()
        },
    }
}